<div class="dc-modal">
  <div class="dc-modal-container bg-white min-w-3xs! max-w-[450px]!">
    <div class="text-center space-y-3 px-4 py-6">
      @if (title) {
      <div class="confirmation-modal-icon-wrap">
        <span class="mx-auto mb-6 grid size-20 place-items-center rounded-full bg-[rgba(18,61,141,0.08)] text-2xl text-[#123d8d]">
          <img src="/icons/svg/warning.svg" class="confirmation-modal-icon" />
        </span>
      </div>
      <h2 class="text-xl font-semibold text-dc-navy">
        {{ title | translate }}
      </h2>
      }
      <p class="text-base! text-dc-navy! leading-relaxed modal-message">
        {{ message | translate }}
      </p>
    </div>
    <div class="flex gap-3 justify-center pb-6">
      @if(!loading){
      @if(showCancel){
      <app-button
        type="button"
        classesName="card-edge-cut-white min-w-30"
        [label]="cancelLabel | translate"
        [disabled]="loading"
        (onBtnClick)="onCancel()"
      ></app-button>
      }
      <app-button
        type="button"
        classesName="btn-edge-cut min-w-30"
        [label]="confirmLabel | translate"
        [disabled]="loading"
        (onBtnClick)="onConfirm()"
      ></app-button>
      } @if(loading){
      <app-button
        type="button"
        classesName="btn-edge-cut btn-width-auto"
        [label]="'PLEASE_WAIT' | translate"
        [disabled]="true"
      ></app-button>
      }
    </div>
  </div>
</div>
